import { createSelector } from 'reselect';
import { convertArrayToObject } from 'utils/helpers';

const userManagementSelector = (state) => state.umsUser;

export const selectUsers = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.users
);

export const selectUsersLoading = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.usersLoading
);

export const selectRoles = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.roles
);

export const selectRoleById = createSelector(
  [userManagementSelector],
  (umsUser) => convertArrayToObject(umsUser.roles, 'id')
);

export const selectRolesLoading = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.rolesLoading
);

export const selectCurrentRole = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.currentRole
);

export const selectCurrentRoleLoading = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.currentRoleLoading
);

export const savingRole = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.savingRole
);

export const deletingRole = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.deletingRole
);

export const selectPrivileges = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.privileges
);

export const selectPrivilegesLoading = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.privilegesLoading
);

export const selectStatistics = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.statistics
);

export const statisticsLoading = createSelector(
  [userManagementSelector],
  (umsUser) => umsUser.statisticsLoading
);
